import { Component, Input } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { ColumnDefinition } from '../models/column-definition';

import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-table-header-cell',
    templateUrl: './table-header-cell.component.html',
    styleUrls: ['./table-header-cell.component.scss'],
    imports: [MatFormFieldModule, MatSortModule]
})
export class TableHeaderCellComponent {
    /**
     * Définition de la colonne affichée.
     */
    private _column: ColumnDefinition;

    @Input()
    public set column(value: ColumnDefinition) {
        this._column = value;
    }

    public get column(): ColumnDefinition {
        return this._column;
    }
}
